export default __webpack_public_path__ + "static/media/50.441c2e7a.svg";